/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Category_Sort_LatestInputs */

const en_directory_category_sort_latest = /** @type {(inputs: Directory_Category_Sort_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest`)
};

const zh_directory_category_sort_latest = /** @type {(inputs: Directory_Category_Sort_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新`)
};

/**
* | output |
* | --- |
* | "Latest" |
*
* @param {Directory_Category_Sort_LatestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_category_sort_latest = /** @type {((inputs?: Directory_Category_Sort_LatestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Category_Sort_LatestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_category_sort_latest(inputs)
	return zh_directory_category_sort_latest(inputs)
});
export { directory_category_sort_latest as "directory.category.sort_latest" }